import { Suspense } from 'react'
import type { FC } from 'react'

import { IconsTypes, type IIconProps } from './icon.types'

import { Skeleton } from '..'

export const Icon: FC<IIconProps> = ({ icon, ...props }) => {
    const IconSvg = IconsTypes[icon]

    return (
        <Suspense
            fallback={
                <Skeleton
                    isLoading
                    borderRadius={props.size}
                    height={props.size}
                    width={props.size}
                />
            }
        >
            <IconSvg {...props} />
        </Suspense>
    )
}
